import { map } from "rxjs/operators";
import { combineLatest, from, Observable } from "rxjs";
import { FormControlItem } from "@/cs-ts-bridge/ts/form-control-item";
import { BaseControlDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { RadioGroupSettings } from "@cs-ts/radio-group-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class RadioGroupDef extends BaseControlDef<RadioGroupSettings, FormDefinitionItem<RadioGroupSettings>, FormControlItem, string> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormControlItem, definitionData: FormDefinitionItem<RadioGroupSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFRadioGroup"; // TODO - not hardcoded?
        this.isFocusable = true;
    }

    effectiveItems$() {
        const items = this.definition.settings.items ?? [];
        const item$s = [];
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            let label$: Observable<(string | undefined)[]>;
            if (item.labelCalculationId) {
                label$ = this.resolveCalculation(item.labelCalculationId, null);
            } else {
                label$ = from([[item.label]]);
            }
            let value$: Observable<(string | undefined)[]>;
            if (item.valueCalculationId) {
                value$ = this.resolveCalculation(item.valueCalculationId, null);
            } else {
                value$ = from([[item.value]]);
            }
            item$s.push(combineLatest([label$, value$]).pipe(map(([label, value]) => (label.length >= value.length ? label.map((i, j) => ({ label: i, value: value[j] })) : value.map((i, j) => ({ value: i, label: label[j] }))).map(({ label, value }) => ({ label, value: value == null || /^\s*$/.test(value) ? label : value })).filter(x => x.label != null || x.value != null))));
        }
        return combineLatest(item$s).pipe(
            //tap(i => { let a = i; debugger; }),
            map(i => i.flat()),
        );
    }
}
